var _defs, _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgBgBlob = function SvgBgBlob(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 380 768",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.2386577%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "standart-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE171A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0545",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "standart-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22119",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30F44",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.8921116%",
    y1: "0%",
    x2: "44.1428913%",
    y2: "104.865882%",
    id: "standart-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E93014",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E91F3E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.2262881%",
    y1: "0.150141636%",
    x2: "50.016526%",
    y2: "99.7994088%",
    id: "islamic-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5E34",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085A37",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "islamic-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6B2C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6A2C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.8921116%",
    y1: "0%",
    x2: "44.1428913%",
    y2: "104.865882%",
    id: "islamic-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#417C35",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407C36",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.2262881%",
    y1: "0.150141636%",
    x2: "50.016526%",
    y2: "99.7994088%",
    id: "elite-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B0C27",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3B54",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.6548357%",
    y1: "2.96613147%",
    x2: "45.7069954%",
    y2: "100%",
    id: "elite-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#730D2B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A04964",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.8921116%",
    y1: "0%",
    x2: "44.1428913%",
    y2: "104.865882%",
    id: "elite-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#811031",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B45773",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.1513e-13 0h315.49c34.943 119.33 55.774 241.33 62.493 366s-6.7197 258.67-40.318 402h-337.67v-768z",
    fill: "url(#standart-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-3.1513e-13 0h315.49c34.943 119.33 55.774 241.33 62.493 366s-6.7197 258.67-40.318 402h-337.67v-768z",
    fill: "url(#standart-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h276.18c32.255 136.67 36.958 274.67 14.111 414s-66.189 257.33-130.03 354h-160.27v-768z",
    fill: "url(#standart-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1.4324e-14 732v-732h239.89c21.503 140.67 10.416 274-33.263 400s-112.56 236.67-206.63 332z",
    fill: "url(#standart-3)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBgBlob, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bg-blob.3636fc64.svg";
export { ForwardRef as ReactComponent };